import { axiosInstance } from '../api';


export default function (userId) {
    return axiosInstance.post(`/api/users/${userId}/archive`);
}